import { render, staticRenderFns } from "./StatsReview.vue?vue&type=template&id=f8163f50&"
import script from "./StatsReview.vue?vue&type=script&lang=js&"
export * from "./StatsReview.vue?vue&type=script&lang=js&"
import style0 from "./StatsReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatsReview.vue"
export default component.exports